<template>
  <section id="links" class="links">
    <h2>{{ $t("Home.links") }}</h2>
    <div class="links__container">
      <a href="https://gitlab.com/josros" class="links__pill glass-card">Gitlab</a>
      <a href="https://medium.com/@jh.rossa" class="links__pill glass-card">Medium</a>
      <a
        href="https://www.linkedin.com/in/josef-rossa-213137115/"
        class="links__pill glass-card"
        >LinkedIn</a
      >
      <a href="/Introduction/index.html" class="links__cta">{{
        $t("Home.virtualIntro")
      }}</a>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "JroLinksNew",
});
</script>

<style lang="scss" scoped>
@use "../global.scss" as *;

.links {
  padding: 4rem 1.5rem 5rem;
  text-align: center;
}

.links__container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.links__pill {
  display: inline-flex;
  align-items: center;
  padding: 0.65rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--foreground);
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-soft-lg);
  }
}

.links__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.65rem 1.75rem;
  border-radius: 999px;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--primary-foreground);
  background: var(--brand-primary);
  box-shadow: var(--shadow-soft);
  transition: transform 0.2s, box-shadow 0.2s, filter 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-soft-lg);
    filter: brightness(1.05);
  }
}

@media (max-width: $bp-medium) {
  .links__container {
    flex-direction: column;
  }

  .links__pill,
  .links__cta {
    width: 100%;
    max-width: 16rem;
    justify-content: center;
  }
}
</style>
